import { useT } from '../../i18n';
import { Select } from '../../ui';
import { MAX_SEATS, MIN_SEATS } from './plans';

const OPTIONS = Array.from({ length: MAX_SEATS - MIN_SEATS + 1 }, (_, i) => {
  const n = MIN_SEATS + i;
  return { value: String(n), label: String(n) };
});

/** Choix du nombre de techniciens (1 à 25) d'un plan facturé par technicien et par mois. */
export function SeatsField({ value, onChange, disabled }: { value: number; onChange: (n: number) => void; disabled?: boolean }) {
  const { t } = useT();
  return <Select label={t('billing.seats.label')} hint={t('billing.seats.hint')} options={OPTIONS} value={String(value)} disabled={disabled} onChange={(e) => onChange(Number(e.target.value))} />;
}

/** Valeur initiale proposée : techniciens déjà présents (au moins 1), bornée à la plage autorisée. */
export function defaultSeats(used: number, current?: number): number {
  return Math.min(MAX_SEATS, Math.max(MIN_SEATS, current ?? used));
}
